import React, { useEffect } from 'react';

// Component loading đơn giản và hiệu quả
const SimpleLoading = ({ 
  text = "Đang tải...", 
  size = "medium",
  color = "#ff6b35",
  className = ""
}) => {
  const sizeMap = {
    small: { width: '16px', height: '16px', fontSize: '12px' },
    medium: { width: '24px', height: '24px', fontSize: '14px' },
    large: { width: '32px', height: '32px', fontSize: '16px' }
  };

  const currentSize = sizeMap[size] || sizeMap.medium;

  return (
    <div 
      className={`simple-loading ${className}`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '16px',
        color: 'var(--muted)'
      }}
    >
      <div 
        className="loading-spinner"
        style={{
          width: currentSize.width,
          height: currentSize.height,
          border: `2px solid #f3f3f3`,
          borderTop: `2px solid ${color}`,
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}
      />
      {text && (
        <span style={{ fontSize: currentSize.fontSize }}>
          {text}
        </span>
      )}
      
    </div>
  );
};

// Component loading cho trang
const PageLoading = ({ text = "Đang tải trang..." }) => {
  const sizeMap = {
    large: { width: '32px', height: '32px', fontSize: '16px' }
  };
  const currentSize = sizeMap.large;

  // Inject keyframes animation vào document nếu chưa có
  useEffect(() => {
    if (typeof document === 'undefined') return;
    
    const styleId = 'page-loading-spin-animation';
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @keyframes pageLoadingSpin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);

    return () => {
      const existingStyle = document.getElementById(styleId);
      if (existingStyle) {
        document.head.removeChild(existingStyle);
      }
    };
  }, []);

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        margin: 0,
        padding: 0,
        boxSizing: 'border-box'
      }}
    >
      <div 
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          margin: 0,
          padding: 0
        }}
      >
        <div 
          style={{
            width: currentSize.width,
            height: currentSize.height,
            border: '2px solid #f3f3f3',
            borderTop: '2px solid var(--primary)',
            borderRadius: '50%',
            animation: 'pageLoadingSpin 1s linear infinite',
            margin: 0
          }}
        />
        {text && (
          <span style={{ 
            fontSize: currentSize.fontSize,
            color: 'var(--muted)',
            margin: 0,
            padding: 0
          }}>
            {text}
          </span>
        )}
      </div>
    </div>
  );
};

// Component loading cho component
const ComponentLoading = ({ text = "Đang tải..." }) => (
  <div 
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      minHeight: '100px'
    }}
  >
    <SimpleLoading text={text} size="medium" />
  </div>
);

// Component loading cho hình ảnh
const ImageLoading = () => (
  <div 
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--surface-3)',
      borderRadius: '8px',
      minHeight: '100px'
    }}
  >
    <SimpleLoading text="" size="small" />
  </div>
);

export { SimpleLoading, PageLoading, ComponentLoading, ImageLoading };
export default SimpleLoading;
